import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://lllqncjwqcbrygqujdin.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;

const BUCKET = 'screenshots';

export function getScreenshotUrl(path) {
  if (!supabase) return '';
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data?.publicUrl || '';
}

/**
 * List all screenshot images in the bucket (root level)
 */
export async function fetchScreenshots() {
  if (!supabase) return [];
  const { data, error } = await supabase.storage
    .from(BUCKET)
    .list('', {
      limit: 200,
      sortBy: { column: 'name', order: 'asc' },
    });

  if (error) {
    console.error('Error fetching screenshots:', error.message);
    return [];
  }

  return (data || [])
    .filter(file => {
      if (!file.id) return false;
      const mime = file.metadata?.mimetype || '';
      return mime.startsWith('image/');
    })
    .map(file => ({
      id: file.id,
      name: file.name,
      url: getScreenshotUrl(file.name),
    }));
}
